import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { EntryContext } from '../../contexts/entryContext';

const InnerLayout = ({ banner, pageClass, children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const { game, revealGames, siteAssets } = useContext(EntryContext);

    useEffect(() => {
        // Initialize the first optional GTM destination if SG's GA4 code is present
        if (game?.g4code?.length) {
            const tagManagerArgs = {
                gtmId: game?.g4code,
            };
            TagManager.initialize(tagManagerArgs);
        }

        // Initialize the second optional GTM destination if Lottery's GA4 code is present
        if (game?.g4codeLottery?.length) {
            const tagManagerArgs = {
                gtmId: game?.g4codeLottery,
            };
            TagManager.initialize(tagManagerArgs);
        }
    }, [game?.g4code, game?.g4codeLottery, location.pathname]);

    useEffect(() => {
        if (!(game?.game_id && revealGames?.length && siteAssets?.name)) {
            return navigate(`/`, { replace: true });
        }
    }, [game?.game_id, siteAssets?.name, revealGames?.length, navigate]);

    return (
        <>
            <div className={`inner-page ${pageClass ? pageClass : ''} ${banner ? '' : ''}`}>
                <div className='page-content'>{children}</div>
            </div>
        </>
    );
};

export default InnerLayout;
